import { atLeast } from '../utils/breakpoints';
import { onScrollEnd } from '../utils/debounce';

// Intro page animation (templates/intro.php): the video is only shown from the
// medium breakpoint up, so it is only loaded and played there. With reduced
// motion it shows its first frame and stays still. It pauses while its section
// is faded out (scroll keyframes, opacity 0 after the first 600px).
export default function introAnimation() {
    const video = document.querySelector('.intro-anim-video');
    if (!video || !atLeast('medium')) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.preload = 'auto';
        return;
    }

    // Default wait (300ms) outlasts the keyframes' 200ms smoothing.
    onScrollEnd(() => {
        const hidden = getComputedStyle(video.parentElement).opacity === '0';
        if (hidden && !video.paused) video.pause();
        else if (!hidden && video.paused) video.play().catch(() => {});
    });
}
